import cs from 'classnames';

import renderButton from './renderButton';

const Footer = ({ footerActions, handleClose, className, isFooter = true }) => {
  const otherContent = footerActions?.other;
  const primaryButton = footerActions?.primary;
  const secondaryButton =
    footerActions?.secondary === undefined
      ? { text: 'Close', onClick: handleClose }
      : footerActions?.secondary;

  const hasContent = isFooter && (otherContent || primaryButton || secondaryButton);

  if (!hasContent) return null;

  return (
    <div className={cs('Modal__footer h-[56px] min-w-0', className)}>
      <div className="flex w-full items-center justify-between gap-3">
        <div className="flex items-center">{otherContent}</div>
        <div className="ml-auto flex items-center gap-3">
          {renderButton({
            config: secondaryButton,
            defaultText: 'Close',
            defaultVariant: 'tertiary',
            defaultOnClick: handleClose,
            defaultDataQa: 'close-modal-btn'
          })}
          {renderButton({
            config: primaryButton,
            defaultText: 'Save',
            defaultVariant: 'primary',
            defaultDataQa: 'primary-modal-btn'
          })}
        </div>
      </div>
    </div>
  );
};

export default Footer;
